import axios from 'axios';
/**
 *
 * @param {String} handle - prodcut handle
 * @returns {Function} -  aysnc function that returns a promise of product data for the handle
 */
const axiosGetFullProductJSON = handle => {
  return async () => {
    let currencyQuery = '';
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currencyQuery = `?currency=${window.Shopify.currency.active}`;
    }
    const res = await axios.get(`/products/${handle}.js${currencyQuery}`);
    if (res) {
      return res.data;
    }
  };
};

export default axiosGetFullProductJSON;
